import React, { ReactNode } from 'react';
import { usePromiseTracker } from 'react-promise-tracker';
import { Alert, LoadingSpinner } from 'vetrf-ui';
import { DefaultFindFnParams, PaginationResponse } from 'components/registry/types/api';
import { RegistryPagination } from '../RegistryPagination';

type RegistryTableProps<T> = {
  handleParamChange: (item: Partial<DefaultFindFnParams>) => void;
  tableData: PaginationResponse<T> | null;
  children: ReactNode;
};

export const RegistryTable = <T,>({
  handleParamChange,
  tableData,
  children,
}: RegistryTableProps<T>) => {
  const { promiseInProgress } = usePromiseTracker();
  if (!tableData || promiseInProgress)
    return (
      <>
        {!!tableData?.itemList?.length && (
          <RegistryPagination tableData={tableData} handlePaginationChange={handleParamChange} />
        )}
        <Alert messageType="info" className="mt-15">
          <LoadingSpinner color="blue" icon="spinner" spin="spin" text="Список обновляется..." />
        </Alert>
      </>
    );
  return tableData?.itemList?.length ? (
    <>
      <RegistryPagination tableData={tableData} handlePaginationChange={handleParamChange} />
      {children}
      <RegistryPagination tableData={tableData} handlePaginationChange={handleParamChange} />
    </>
  ) : (
    <span>Нет записей</span>
  );
};
